<template>
  <div class="modal-container" @click.stop="">
    <div class="modal-card">
      <div class="title-label">
        Calculation error.
      </div>
      <div class="title-label">
        Please check your inputs.
      </div>
      <div class="buttons-container">
        <div class="ok-button" @click="hideModal">
          OK
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useModalStore } from '@/store/ModalStore';

export default {
  name: 'ModalExcessivePressureDrop',
  methods: {
    hideModal () {
      useModalStore().hideModal();
    }
  }
};
</script>

<style scoped>
.modal-container {
  background-color: white;
  border: 3px solid red;
  height: 150px;
  margin-top: 40vh;
  margin-right: 40vw;
  width: 300px;
}
.modal-card {
  height: 100%;
  width: 100%;
}
.title-label {
  display: flex;
  justify-content: center;
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 10px;
}
.buttons-container {
  display: flex;
  margin-left: 5%;
  margin-top: 20px;
  width: 90%;
}
.ok-button {
  border: 1px solid black;
  cursor: pointer;
  display: flex;
  justify-content: center;
  margin-left: 30%;
  width: 40%;
}
</style>
